import { useState } from 'react';
import './ReportSection.css';
import './ReportSectionImgCard.css'

const ReportSectionImgCard = ({ title, imgSource, imgAltText, text, stackVertical=false, badgeText=null }) => {
  
  const [isModalActive, setIsActive] = useState(false);
  const toggleModal = () => {
    setIsActive(!isModalActive);
  };

  return (
    <div className="text-by-image" onClick={toggleModal}>
      <div className="columns">
        <div className="column is-12">
          <div className="content">
            <h2>
              {title}
              {badgeText && <span className="tag is-light ml-3">{badgeText}</span>}
            </h2>
          </div>
        </div>
      </div>      
      {stackVertical && (
        <div>
          <div className="block">
            <a className="image">
              <img
                src={imgSource}
                alt={imgAltText}
              />
            </a>
          </div>
          <div className="block is-5">
            <div className="content">            
              {text}
            </div>
          </div>      
        </div>
      )}
      {!stackVertical && (
        <div className="columns">
          <div className="column is-7">
            <a className="image">
              <img
                src={imgSource}
                alt={imgAltText}
              />
            </a>
          </div>
          <div className="column is-5">
            <div className="content">            
              {text}
            </div>
          </div>      
        </div>
      )}
      <div className={`modal ${isModalActive ? 'is-active' : ''}`}>        
        <div className="modal-background modal-background"></div>
        <button className="modal-close is-large modal-close-margin" aria-label="close"></button>
        <div className="modal-content has-background-white ">
          <div className='block p-6'>
            <figure className="image">
              <img
                  src={imgSource}
                  alt={imgAltText}
                />
            </figure>
          </div>          
        </div>
        <button className="modal-close is-large" aria-label="close"></button>
      </div>

    </div>
  );
};
  
 /**return (
    <div className="card">
      <header className="card-header">
        <p className="card-header-title"></p>
      </header>
      <div className="card-image">
        <figure className="image is-4by3">
          <img
            src={imgSource}
            alt={imgAltText}
          />
        </figure>
      </div>
      <div className="card-content">
        <div className="content">
          <h3>{title}</h3>
          {text}
        </div>
      </div>
    </div>    
  );
};
*/

export default ReportSectionImgCard;
